import PrivateDirectoryApiModel from '../../abstracts/DirectoryPrivateApiModel';

export default class ContactModel extends PrivateDirectoryApiModel {
	public filters: ModelFiltersExtended<object> = {};

	static get path(): string {
		return '/mails/{?id}';
	}
}
